/**
 *  UserDropdown script file
**/
import Portal from '@/directives/portal'
import authService from '@/api/authService'

export default {
  name: 'UserDropdown',
  mixins: [],
  directives: { portal: Portal },
  components: {
    PasswordModal: () => import('@/components/password-modal/PasswordModal.vue')
  },
  props: {},
  data () {
    return {
      showPasswordModal: false
    }
  },
  computed: {
    user () {
      return authService.getAuth() || {}
    }
  },
  methods: {
    updateScrollbar () {
      this.$nextTick(() => {
        this.$refs.scrollbar.update()
      })
    },
    changePassword () {
      this.$emit('close')
      this.showPasswordModal = true
    },
    logout () {
      authService.logout()
      this.$router.push('/login')
    },
    closeModal () {
      this.showPasswordModal = false
    }
  }
}
